import { __awaiter as p, __generator as v, __assign as y } from "./index11.js";
import "./index14.js";
import { toFacade as m } from "./index52.js";
import { ContextCancelation as b } from "./index43.js";
function E(o, u, r) {
  return p(this, void 0, void 0, function() {
    function t(a, g) {
      return p(this, void 0, void 0, function() {
        var c, n, d;
        return v(this, function(h) {
          switch (h.label) {
            case 0:
              return c = !1, n = null, [4, g({
                payload: m(a, {
                  clone: !0,
                  traverse: !1
                }),
                integration: o,
                next: function(f) {
                  c = !0, f === null && (n = null), f && (n = f.obj);
                }
              })];
            case 1:
              return h.sent(), !c && n !== null && (n = n, n.integrations = y(y({}, a.integrations), (d = {}, d[o] = !1, d))), [2, n];
          }
        });
      });
    }
    var e, i, l, w, s;
    return v(this, function(a) {
      switch (a.label) {
        case 0:
          e = m(u, {
            clone: !0,
            traverse: !1
          }).rawEvent(), i = 0, l = r, a.label = 1;
        case 1:
          return i < l.length ? (w = l[i], [4, t(e, w)]) : [3, 4];
        case 2:
          if (s = a.sent(), s === null)
            return [2, null];
          e = s, a.label = 3;
        case 3:
          return i++, [3, 1];
        case 4:
          return [2, e];
      }
    });
  });
}
function j(o, u) {
  function r(t) {
    return p(this, void 0, void 0, function() {
      var e;
      return v(this, function(i) {
        switch (i.label) {
          case 0:
            return e = !1, [4, o({
              payload: m(t.event, {
                clone: !0,
                traverse: !1
              }),
              integrations: u ?? {},
              next: function(l) {
                e = !0, l && (t.event = l.obj);
              }
            })];
          case 1:
            if (i.sent(), !e)
              throw new b({
                retry: !1,
                type: "middleware_cancellation",
                reason: "Middleware `next` function skipped"
              });
            return [2, t];
        }
      });
    });
  }
  return {
    name: "Source Middleware ".concat(o.name),
    type: "before",
    version: "0.1.0",
    isLoaded: function() {
      return !0;
    },
    load: function(t) {
      return Promise.resolve(t);
    },
    track: r,
    page: r,
    identify: r,
    alias: r,
    group: r
  };
}
export {
  E as applyDestinationMiddleware,
  j as sourceMiddlewarePlugin
};
//# sourceMappingURL=index9.js.map
